import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
  list: [],
  payment: null,
  error: "",
  loading: false,
};

// ADD_ Payment to payslip
export const addPayslipPayment = createAsyncThunk(
  "payslip/addPayslipPayment",
  async (id) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `payroll/payment/${id}`,
      });
      toast.success("Payment Created Successfully");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding Payment try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const EmployeePaymentTypeHistorySetup = createAsyncThunk(
  "shift/EmployeePaymentTypeHistorySetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `employee/EmployeePaymentTypeHistorySetup`,
        data: {
          ...values,
        },
      });
      toast.success("Employment Status Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding Employment Status try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

export const EmployeeCompanyOfficeHistorySetup = createAsyncThunk(
  "shift/EmployeeCompanyOfficeHistorySetup",
  async (values) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `employee/EmployeeCompanyOfficeHistorySetup`,
        data: {
          ...values,
        },
      });
      toast.success("Employment Status Added");
      return {
        data,
        message: "success",
      };
    } catch (error) {
      toast.error("Error in adding Employment Status try again");
      // console.log(error.message);
      return {
        message: "error",
      };
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    clearPayment: (state) => {
      state.payment = null;
    },
  },
  extraReducers: (builder) => {
    // 2) ====== builders for addPayslipPayment ======

    builder.addCase(addPayslipPayment.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(addPayslipPayment.fulfilled, (state, action) => {
      state.loading = false;

      state.payment = action.payload.data;
    });

    builder.addCase(addPayslipPayment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });

    builder.addCase(EmployeePaymentTypeHistorySetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      EmployeePaymentTypeHistorySetup.fulfilled,
      (state, action) => {
        state.loading = false;

        if (!Array.isArray(state.list)) {
          state.list = [];
        }
        const list = [...state.list];
        list.push(action.payload);
        state.list = list;
      }
    );

    builder.addCase(
      EmployeePaymentTypeHistorySetup.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );

    builder.addCase(EmployeeCompanyOfficeHistorySetup.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      EmployeeCompanyOfficeHistorySetup.fulfilled,
      (state, action) => {
        state.loading = false;

        if (!Array.isArray(state.list)) {
          state.list = [];
        }
        const list = [...state.list];
        list.push(action.payload);
        state.list = list;
      }
    );

    builder.addCase(
      EmployeeCompanyOfficeHistorySetup.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      }
    );


    // 3) ====== builders for loadSinglePayslip ======
  },
});

export default paymentSlice.reducer;
export const { clearPayment } = paymentSlice.actions;
